<template>
  <div class="content">
    <div class="page-inner">
      <div class="card card-dark bg-primary-gradient magictime puffIn" v-show="!loading && !allArtist.length">
        <div class="card-header mb-1 pb-1">
          <div class="card-title pb-0 mb-0 fw-bold">
            {{ $t('lets_create_artist') }}
          </div>
        </div>
        <div class="card-body pt-1">
          {{ $t('artist_form_welcome') }}
        </div>
      </div>
      <div class="page-header mb-3" v-show="allArtist.length">
        <router-link to="/artists">
          <i class="fa fa-chevron-left mr-1"></i>
          {{ $t('artists') }}
        </router-link>
      </div>
      <div class="row" v-show="!loading" :class="{ 'animated fadeInUp animation-delay-400': !loading && !allArtist.length }">
        <div class="col-md-12">
          <div class="mb-3" v-if="artist._id">
            <router-link :to="`/artists/${artist.key}/public`" class="btn btn-gradient btn-block">
              <i class="fa fa-edit mr-1"></i> {{ $t('edit_website') }}
            </router-link>
          </div>
          <div class="card">
            <div class="card-header clearfix" v-if="allArtist.length">
              <div class="pull-left">
                <div class="card-title" v-if="!artist._id">{{ $t('new_artist') }}</div>
                <div class="card-title" v-if="artist._id">{{ artist.name }}</div>
                <div class="card-category d-none d-sm-block">{{ $t('fill_all_required') }}</div>
              </div>
            </div>
            <form @submit.prevent="submitArtist()" id="artist-form">
              <div class="card-body">
                <div class="form-group form-show-validation row" :class="{ 'has-error': invalidTitle }">
                  <label for="artist-name" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">{{ $t('artist_name') }} <span class="required-label">*</span></label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <input type="text" v-model="artist.name" class="form-control" id="artist-name" name="name" placeholder="" required :readonly="!!artist._id" @input="validateName()" maxlength="100">
                    <small class="form-text text-danger" v-if="invalidTitle">{{ $t('artist_instructions') }}</small>
                  </div>
                </div>
                <div class="form-group form-show-validation row">
                  <label for="birth" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">{{ $t('main_genre') }} <span class="required-label">*</span></label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <div class="select2-input">
                      <Select2 v-model="artist.main_genre" :options="genres"></Select2>
                    </div>
                  </div>
                </div>
                <div class="form-group form-show-validation row">
                  <label for="birth" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">{{ $t('country') }} <span class="required-label">*</span></label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <div class="select2-input">
                      <Select2 v-model="artist.legal_country" :options="countries"></Select2>
                    </div>
                  </div>
                </div>
                <hr>
                <div ref="legalNameForm" class="card-category mb-2">{{ $t('artist_legal_info') }}</div>
                <div class="form-group form-show-validation row">
                  <label for="first-name" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">{{ $t('name') }} <span class="required-label">*</span></label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <div class="input-group">
                      <input
                        type="text"
                        v-model="artist.legal_name"
                        required
                        class="form-control"
                        placeholder="John"
                        name="first_name"
                        :disabled="!artist.name"
                        @drop="$event.preventDefault()" @dragenter.prevent @dragover.prevent
                        @input="handleInput('legal_name')"
                        @blur="validateLegalName"
                        @paste.prevent
                        maxlength="100"
                      />
                    </div>
                  </div>
                </div>
                <div class="form-group form-show-validation row">
                  <label for="first-name" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">{{ $t('last_name') }} <span class="required-label">*</span></label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <div class="input-group">
                      <input
                        type="text"
                        v-model="artist.legal_last_name"
                        required
                        class="form-control"
                        placeholder="Doe"
                        name="last_name"
                        :disabled="!artist.name"
                        @input="handleInput('legal_last_name')"
                        @drop="$event.preventDefault()" @dragenter.prevent @dragover.prevent
                        @blur="validateLegalName()"
                        @paste.prevent
                        maxlength="100"
                      />
                    </div>
                  </div>
                </div>
                <div class="form-group form-show-validation row" v-if="invalidNameReason">
                  <label for="first-name" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2"></label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <div class="alert alert-warning">
                      {{ invalidNameReason }}
                    </div>
                  </div>
                </div>
                <div class="form-group form-show-validation row">
                  <label for="artist-email" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">{{ $t('email') }} <span class="required-label">*</span></label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <input type="email" v-model="user.email" class="form-control" id="artist-email" name="email" required>
                  </div>
                </div>
                <div v-if="user.verified">
                  <div v-if="artist.payment_method === 'stripe'">
                    <div class="form-group form-show-validation row" v-if="user.stripe_completed">
                      <label class="col-lg-3 col-md-3 col-sm-4 text-right m-0">
                        <img src="/static/img/stripe-logo.png" alt="logo-stripe" class="logo-stripe">
                      </label>
                      <div class="col-lg-4 col-md-5 col-sm-8">
                        <div class="border rounded p-0 mt-2 mb-2 mr-0 p-2 pl-3">
                          {{ $t('user_already_stripe_account') }} <br>
                          <router-link to="/account" class="text-underline" type="button">
                            {{ $t('view_account') }}
                          </router-link>
                          <small class="form-text text-muted">
                            <i>{{ $t('current_payment_method') }}</i>
                          </small>
                        </div>
                      </div>
                    </div>
                    <div class="form-group form-show-validation row" v-else>
                      <label class="col-lg-3 col-md-3 col-sm-4 text-right m-0">
                        <img src="/static/img/stripe-logo.png" alt="logo-stripe" class="logo-stripe">
                      </label>
                      <div class="col-lg-4 col-md-5 col-sm-8">
                        <div class="border rounded p-0 mt-2 mb-2 mr-0 p-2 pl-3">
                          {{ $t('stripe_set_up') }} <br>
                          <router-link to="/account" class="text-underline" type="button">
                            {{ $t('view_account') }}
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="artist.payment_method === 'wise'">
                    <div class="form-group form-show-validation row" v-if="user.payments_details">
                      <label class="col-lg-3 col-md-3 col-sm-4 text-right m-0 pt-2">
                        <img src="https://wise.com/public-resources/assets/logos/wise/brand_logo.svg">
                      </label>
                      <div class="col-lg-4 col-md-5 col-sm-8">
                        <div class="border rounded p-0 mt-2 mb-2 mr-0 p-2 pl-3">
                          {{ $t('user_already_wise_account') }} <br>
                          <router-link to="/account" class="text-underline" type="button">
                            {{ $t('view_account') }}
                          </router-link>
                          <small class="form-text text-muted">
                            <i>{{ $t('current_payment_method') }}</i>
                          </small>
                        </div>
                      </div>
                    </div>
                    <div class="form-group form-show-validation row" v-else>
                      <label class="col-lg-3 col-md-3 col-sm-4 text-right m-0 pt-2">
                        <img src="https://wise.com/public-resources/assets/logos/wise/brand_logo.svg">
                      </label>
                      <div class="col-lg-4 col-md-5 col-sm-8">
                        <div class="border rounded p-0 mt-2 mb-2 mr-0 p-2 pl-3">
                          {{ $t('wise_set_up') }} <br>
                          <router-link to="/account" class="text-underline" type="button">
                            {{ $t('view_account') }}
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div v-if="!artist.payment_method">
                    <div class="form-group form-show-validation row">
                      <label class="col-lg-3 col-md-3 col-sm-4 text-right m-0 pt-2">
                        {{ $t('royalty_payments') }}
                      </label>
                      <div class="col-lg-4 col-md-5 col-sm-8">
                        <div class="border rounded p-0 mt-2 mb-2 mr-0 p-2 pl-3">
                          {{ $t('user_dont_have_payment_account') }} <br>
                          <router-link to="/account" class="text-underline" type="button">
                            {{ $t('view_account') }}
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div> -->
                </div>
                <div class="separator-solid"></div>
                <div class="card-category mb-2">{{ $t('social_important') }}</div>
                <div class="form-group row">
                  <div class="offset-sm-4 offset-md-3 offset-lg-3 col-lg-4 col-md-9 col-sm-8">
                    <div class="alert alert-warning mb-1">
                      {{ $t('one_social_required') }}
                    </div>
                  </div>
                </div>
                <div class="form-group form-show-validation row">
                  <label for="first-name" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">Instagram <span class="required-label"></span></label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="instagram-addon">@</span>
                      </div>
                      <input type="text" v-model="artist.instagram" class="form-control" placeholder="" aria-label="instagram" aria-describedby="instagram-addon" name="instagram" :disabled="disabledClass('instagram')">
                    </div>
                  </div>
                </div>
                <div class="form-group form-show-validation row">
                  <label for="first-name" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">Twitter <span class="required-label"></span></label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="twitter-addon">@</span>
                      </div>
                      <input type="text" class="form-control" v-model="artist.twitter" placeholder="" aria-label="twitter" aria-describedby="twitter-addon" name="twitter" :disabled="disabledClass('twitter')">
                    </div>
                  </div>
                </div>
                <div class="form-group form-show-validation row">
                  <label for="first-name" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">Facebook Page <span class="required-label"></span></label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="username-addon">facebook.com/</span>
                      </div>
                      <input type="text" v-model="artist.facebook" class="form-control" placeholder="" aria-label="first_name" aria-describedby="username-addon" name="first_name" :disabled="disabledClass('facebook')">
                    </div>
                  </div>
                </div>
                <div class="form-group form-show-validation row" v-show="artist._id">
                  <label for="first-name" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">Spotify URL<span class="required-label"></span></label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <input type="url" class="form-control" v-model="artist.spotify" placeholder="" aria-label="spotify" aria-describedby="spotify-addon" name="spotify" :disabled="disabledClass('spotify')">
                  </div>
                </div>
                <div class="form-group form-show-validation row" v-show="artist._id">
                  <label for="first-name" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">Apple Music URL<span class="required-label"></span></label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <input type="url" class="form-control" v-model="artist.apple_music" placeholder="" aria-label="apple-music" aria-describedby="spotify-addon" name="apple_music" :disabled="disabledClass('apple_music')">
                  </div>
                </div>
                <div class="form-group form-show-validation row">
                  <label for="first-name" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">Youtube Channel</label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <input type="text" v-model="artist.youtube" class="form-control" :disabled="disabledClass('youtube')">
                  </div>
                </div>
                <!-- <div class="form-group form-show-validation row">
                  <label for="first-name" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">Website</label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <input type="text" v-model="artist.website" class="form-control" :disabled="disabledClass('website')">
                  </div>
                </div> -->
                <div class="form-group form-show-validation row" v-show="artist.name">
                  <label for="first-name" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">{{ $t('spotify_profile') }} <i class="fab fa-spotify text-success ml-1"></i> <span class="required-label ml-1">*</span></label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <select class="form-control" v-model="haveSpotify" required>
                      <option value=""></option>
                      <option value="no">{{ $t('i_do_not_have_spotify') }}</option>
                      <option value="yes">{{ $t('already_have_spotify') }}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group form-show-validation row" v-show="haveSpotify === 'yes'">
                  <label class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">
                    <!-- {{ $t('spotify_profile') }} -->
                  </label>
                  <div class="col-md-4 mt-2">
                    <div class="card mb-0 pos-relative already-spotify animated fadeInLeft">
                      <div class="card-body pt-2 pb-2">
                        <div v-show="!spotifyProfile" class="mt-2 mb-2 pt-3 pb-3 pl-2 pr-2 text-center profile-selector" @click="searchSpotifyArtist()">
                          <b>{{ $t('select_profile') }}</b>
                        </div>
                        <div class="card-list p-0 mt-2" v-if="spotifyProfile">
                          <div class="item-list p-0 d-flex align-items-center">
                            <div class="avatar-sm flex-shrink-0">
                              <img
                                :src="spotifyProfile.cover_image_small || (spotifyProfile.images && spotifyProfile.images[0] && spotifyProfile.images[0].url) || defaultImage"
                                :alt="$t('spotify_artist')"
                                class="avatar-img rounded-circle"
                                style="width: 48px; height: 48px; object-fit: cover;"
                              >
                            </div>
                            <div class="info-user mt-2 ml-3 flex-grow-1" style="min-width:0;">
                              <div class="h4 mb-0 text-truncate" style="max-width: 220px;">
                                <span v-if="spotifyProfile.name">{{ spotifyProfile.name }}</span>
                                <span v-else-if="artist.spotify_id" class="text-truncate" style="display:inline-block; max-width:180px; vertical-align:bottom;">
                                  {{ $t('spotify_artist_id') }}: {{ artist.spotify_id.slice(0, 16) + '...' }}
                                </span>
                                <span v-else class="text-muted">{{ $t('no_spotify_artist_selected') }}</span>
                              </div>
                              <div v-if="artist.spotify_id" class="h5 text-muted followers">
                                <a
                                  :href="`https://open.spotify.com/artist/${artist.spotify_id.replace('spotify:artist:', '')}`"
                                  target="_blank"
                                >{{ $t('view_spotify') }}</a>
                              </div>
                            </div>
                            <span class="btn btn-sm remove-contributor-icon ml-2 flex-shrink-0" @click="removeSpotifyProfile()">
                              <i class="fas fa-times"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="separator-solid"></div>
                <div class="form-group form-show-validation row">
                  <label class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">{{ $t('artist_image') }}</label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <div class="input-file input-file-image" v-if="artist.cover_image">
                      <img :src="artist.cover_image_small || artist.cover_image" alt="" width="200" class="img-thumbnail"><br/>
                      <button type="button" class="mt-2 btn btn-danger" @click="replaceImage()"><i class="fas fa-trash"></i> {{ $t('remove_image') }}</button>
                    </div>
                    <div class="input-file input-file-image" v-if="!artist.cover_image">
                      <croppa
                        :width="300"
                        :height="300"
                        :prevent-white-space="true"
                        v-model="myCroppa">
                      </croppa>
                      <div class="mt-sm">
                        <button class="btn btn-default btn-sm" type="button" @click="zoomOut()" :disabled="!hasFile">
                          <i class="fa fa-search-minus"></i>
                        </button>
                        <button class="btn btn-default btn-sm" type="button" @click="zoomIn()" :disabled="!hasFile">
                          <i class="fa fa-search-plus"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row" v-if="publishedDistros && !hasSoundcloudWhitelist">
                  <label class="col-lg-3 col-md-3 col-sm-4 mt-2 text-right">{{ $t('request_whitelist') }}</label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <button type="button" class="btn btn-warning btn-xs" @click="openWhitelistModal()">
                      <div class="bg-warning soundcloud-container">
                        <img src="/static/img/soundcloud-logo.png" alt="logo">
                      </div>
                    </button>
                  </div>
                </div>
                <div class="card-body bg-2 container-service" v-if="activeService._id">
                  <fieldset>
                    <legend class="text-14">
                      <span class="title">Detail of selected service</span>
                      <button class="btn btn-danger btn-sm float-right" @click="deleteService(activeService._id)" :disabled="saving" v-if="!artist._id">
                        <i class="fa fa-trash" v-if="!saving"></i>
                        <i class="fa fa-spinner fa-spin" v-if="saving"></i>
                      </button>
                    </legend>
                    <div class="row mb-4">
                      <div class="col-md-12">
                        <div class="separator-solid"></div>
                      </div>
                      <!-- <div class="col-md-3">
                        <div class="form-group">
                          <label>Total</label>
                          <div>{{ currency.format(activeService.total) }}</div>
                        </div>
                      </div> -->
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>Name</label>
                          <div>{{ activeService.service_type.name }}</div>
                        </div>
                      </div>
                      <!-- <div class="col-md-3">
                        <div class="form-group">
                          <label>Payment Method</label>
                          <div class="payment-method">{{ activeService.payment_method }}</div>
                        </div>
                      </div> -->
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>Payment Date</label>
                          <div>{{ moment(activeService.paidAt).format('LLL') }}</div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="separator-solid"></div>
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
              <div class="card-action">
                <div class="row">
                  <div class="col-md-12 text-right">
                    <router-link to="/artists" tag="button" class="btn btn-default btn-border no-border" type="button" v-show="allArtist.length">
                      <i class="fa fa-chevron-left mr-1"></i> {{ $t('cancel') }}
                    </router-link>
                    <button class="btn btn-gradient" type="submit" :disabled="saving">
                      <i class="fa fa-spinner fa-spin" v-if="saving"></i>
                      <span v-if="!saving">{{ $t('save') }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div ref="spotifyModal" class="modal spotifyModal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header pt-4 pb-4">
            <h4 class="modal-title">{{ $t('select_spotify_profile') }}</h4>
          </div>
          <div class="modal-body pr-5 pl-5">
            <p class="text-center p-4" v-if="loadingSpotifyArtists">
              <i class="fa fa-spinner fa-spin text-muted"></i>
            </p>
            <p class="text-center p-4" v-if="!loadingSpotifyArtists && !spotifyArtists.length">
              {{ $t('no_spotify_artists_found') }}
            </p>
            <div class="card-list">
              <div class="item-list" v-for="artist in spotifyArtists" v-bind:key="artist.id">
                <div class="avatar-sm">
                  <img :src="artist.images[0] ? artist.images[0].url : defaultImage" :alt="artist.name" onerror="this.src = '/static/img/img-placeholder.jpg'" class="avatar-img rounded-circle">
                </div>
                <div class="info-user ml-3">
                  <a :href="artist.external_urls.spotify" target="_blank" class="username" v-if="artist.external_urls">
                    {{ artist.name }}
                    <i class="fas fa-external-link-alt"></i>
                  </a>
                  <span class="title-artist" v-if="!artist.external_urls">
                    {{ artist.name }}
                  </span>
                  <div class="status">{{ artist.followers.total }} {{ $t('followers') }}</div>
                </div>
                <button class="btn btn-primary btn-xs spotify-select" @click="selectSpotifyArtist(artist)">
                  {{ $t('select') }}
                </button>
              </div>
            </div>
            <div class="spotify-paginator mt-4" v-if="spotifyArtists.length">
              <div class="paginator previous">
                <button class="btn" @click="searchSpotifyArtist(spotifyPrev)" :disabled="!spotifyPrev">
                  <i class="fas fa-angle-double-left"></i>
                  {{ $t('previous') }}
                </button>
              </div>
              <div class="paginator next">
                <button class="btn" @click="searchSpotifyArtist(spotifyNext)" :disabled="!spotifyNext">
                  {{ $t('next') }}
                  <i class="fas fa-angle-double-right"></i>
                </button>
              </div>
            </div>
            <div class="text-center mt-3">
              <button
                v-if="!showManualSpotifyId"
                class="btn btn-link"
                @click="showManualSpotifyId = true"
              >
                {{ $t('can_not_your_profile_spotify') }}
              </button>
            </div>
            <div v-if="showManualSpotifyId" class="mt-3 p-3 border rounded bg-light">
              <label for="manual-spotify-id" class="font-weight-bold mb-1">
                {{ $t('spotify_artist_id_url') }}
                <span class="text-muted" style="font-size: 12px;">
                  (e.g. <code>spotify:artist:7yaahg4SFaLODTEYxnIlhS</code> or <code>https://open.spotify.com/artist/7yaahg4SFaLODTEYxnIlhS</code>)
                </span>
              </label>
              <input
                id="manual-spotify-id"
                v-model="manualSpotifyId"
                class="form-control"
                :placeholder="$t('paste_spotify_artist_id_url')"
                @input="manualSpotifyIdError = ''; manualSpotifyIdSuccess = ''"
                autocomplete="off"
              />
              <div class="d-flex mt-2">
                <button
                  class="btn btn-primary flex-grow-1 mr-2"
                  @click="submitManualSpotifyId"
                >{{ $t('save_spotify_id') }}</button>
                <button
                  class="btn btn-secondary flex-grow-1"
                  @click="cancelManualSpotifyId"
                >{{ $t('cancel') }}</button>
              </div>
              <div v-if="manualSpotifyIdError" class="alert alert-danger mt-2 py-1 px-2">{{ $t(manualSpotifyIdError) }}</div>
              <div v-if="manualSpotifyIdSuccess" class="alert alert-success mt-2 py-1 px-2">{{ $t(manualSpotifyIdSuccess) }}</div>
            </div>
          </div>
          <div class="modal-footer text-center pt-2">
            <button class="btn mr-2 btn-default btn-border btn-cancel" data-dismiss="modal">{{ $t('close') }}</button>
            <button type="button" class="btn btn-primary" data-dismiss="modal" @click="createSpotifyProfile()">
              {{ $t('create_new') }}
            </button>
          </div>
          <div class="modal-body pr-5 pl-5 pb-4 text-center bottom" v-html="$t('spotify_footer_description')"></div>
        </div>
      </div>
    </div>
    <div ref="requestWhitelistModal" class="modal modal-swal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header">
            {{ 'SoundCloud Whitelist' }}
          </div>
          <div class="modal-body mx-auto">
            <div class="mt-2 mb-custom" v-html="`<i class='fas fa-exclamation-triangle text-danger mr-1'></i>` + ((lang === 'es') ? '<b>Advertencia:</b> Esta cuenta <b>no</b> se monetizará después de la inclusión en la lista blanca.' : '<b>Warning:</b> This account will <b>not</b> be monetized after whitelisting.')"></div>
            <div class="mt-1 mb-3">{{ ((lang === 'es') ? 'Escribe la URL de tu perfil de artista de Soundcloud:' : 'Type your Soundcloud artist profile URL:') }}</div>
            <div class="input-group">
              <input type="text" class="form-control" placeholder="https://soundcloud.com/" aria-describedby="soundCloudURL" v-model="soundCloudURL">
            </div>
            <div class="text-right mb-5 mt-2">
              <a href="https://help.indiefy.net/hc/en-us/articles/360046415053-How-can-I-avoid-Soundcloud-claims-" target="_blank">{{ ((lang === 'es') ? '¿Dónde está mi URL de artista?' : 'Where is my artist link?') }}</a>
            </div>
            <div class="mb-4">
              <div class="mt-1 mb-4">{{ ((lang === 'es') ? '¿Soundcloud creó una página de artista adicional?' : 'Did Soundcloud create an additional artist page?') }}</div>
              <div class="mt-1 mb-4">
                <div class="custom-control custom-checkbox ml-4">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="reviewed"
                    v-model="yesSoundCloud"
                  />
                  <label class="custom-control-label label-break-spaces" for="reviewed">
                    {{ ((lang === 'es') ? 'Sí, eliminen la página genérica duplicada.' : 'Yes, remove duplicate generic page.') }}
                  </label>
                </div>
              </div>
              <div class="mt-1" v-show="yesSoundCloud" v-html="((lang === 'es') ? 'Escribe aquí la URL del perfil de Soundcloud <b>duplicado</b>:' : 'Type your <b>duplicated</b> Soundcloud artist profile URL here:')"></div>
            </div>
            <div class="input-group" v-show="yesSoundCloud">
              <input type="text" class="form-control" placeholder="https://soundcloud.com/" aria-describedby="soundCloudGenericURL" v-model="soundCloudGenericURL">
            </div>
            <div class="text-right mb-5 mt-2" v-show="yesSoundCloud">
              <a href="https://help.indiefy.net/hc/en-us/articles/360046415053-How-can-I-avoid-Soundcloud-claims-" target="_blank">{{ ((lang === 'es') ? '¿Dónde está el URL duplicado?' : 'Where is the duplicate link?') }}</a>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default btn-border no-border" data-dismiss="modal">{{ $t('close') }}</button>
            <button type="button" class="btn btn-primary" data-dismiss="modal" @click="sendRequestSoundCloudWhitelist()" :disabled="!this.soundCloudURL.trim()">
              {{ $t('send') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div ref="tittleValidationModal" class="modal modal-swal modal-h" tabindex="-1" role="dialog" >
      <div class="modal-dialog modal-center" role="document">
        <div class="modal-content">
          <div class="modal-header" >
            {{ $t('title_requirements') }}
          </div>
          <div class="modal-body">
            <div class="text-center" v-html="$t('artist_name_instructions')"></div>
          </div>
          <div class="modal-footer pt-4">
            <button type="button" class="btn btn-primary" data-dismiss="modal">{{ $t('i_understand') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'underscore'
import moment from 'moment'
import Artists from '../services/artists'
import Select2 from './utils/Select2'
import genres from '../data/genres'
import countries from '../data/countries'
import Upload from '../services/upload'
import Distributions from '../services/distributions'
import User from '../services/user'
import ServicesOnDemand from '../services/services-on-demand'
import Public from '../services/public'

const defaultDiacriticsRemovalMap = [
  {'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g},
  {'base': 'AA', 'letters': /[\uA732]/g},
  {'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g},
  {'base': 'AO', 'letters': /[\uA734]/g},
  {'base': 'AU', 'letters': /[\uA736]/g},
  {'base': 'AV', 'letters': /[\uA738\uA73A]/g},
  {'base': 'AY', 'letters': /[\uA73C]/g},
  {'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g},
  {'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g},
  {'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g},
  {'base': 'DZ', 'letters': /[\u01F1\u01C4]/g},
  {'base': 'Dz', 'letters': /[\u01F2\u01C5]/g},
  {'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g},
  {'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g},
  {'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g},
  {'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g},
  {'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g},
  {'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g},
  {'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g},
  {'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g},
  {'base': 'LJ', 'letters': /[\u01C7]/g},
  {'base': 'Lj', 'letters': /[\u01C8]/g},
  {'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g},
  {'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g},
  {'base': 'NJ', 'letters': /[\u01CA]/g},
  {'base': 'Nj', 'letters': /[\u01CB]/g},
  {'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g},
  {'base': 'OI', 'letters': /[\u01A2]/g},
  {'base': 'OO', 'letters': /[\uA74E]/g},
  {'base': 'OU', 'letters': /[\u0222]/g},
  {'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g},
  {'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g},
  {'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g},
  {'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g},
  {'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g},
  {'base': 'TZ', 'letters': /[\uA728]/g},
  {'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g},
  {'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g},
  {'base': 'VY', 'letters': /[\uA760]/g},
  {'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g},
  {'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g},
  {'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g},
  {'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g},
  {'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g},
  {'base': 'aa', 'letters': /[\uA733]/g},
  {'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g},
  {'base': 'ao', 'letters': /[\uA735]/g},
  {'base': 'au', 'letters': /[\uA737]/g},
  {'base': 'av', 'letters': /[\uA739\uA73B]/g},
  {'base': 'ay', 'letters': /[\uA73D]/g},
  {'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g},
  {'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g},
  {'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g},
  {'base': 'dz', 'letters': /[\u01F3\u01C6]/g},
  {'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g},
  {'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g},
  {'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g},
  {'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g},
  {'base': 'hv', 'letters': /[\u0195]/g},
  {'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g},
  {'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g},
  {'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g},
  {'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g},
  {'base': 'lj', 'letters': /[\u01C9]/g},
  {'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g},
  {'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g},
  {'base': 'nj', 'letters': /[\u01CC]/g},
  {'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g},
  {'base': 'oi', 'letters': /[\u01A3]/g},
  {'base': 'ou', 'letters': /[\u0223]/g},
  {'base': 'oo', 'letters': /[\uA74F]/g},
  {'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g},
  {'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g},
  {'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g},
  {'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g},
  {'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g},
  {'base': 'tz', 'letters': /[\uA729]/g},
  {'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g},
  {'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g},
  {'base': 'vy', 'letters': /[\uA761]/g},
  {'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g},
  {'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g},
  {'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g},
  {'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g}
]

export default {
  name: 'ArtistForm',
  data: function () {
    return {
      invalidNameReason: '',
      loading: true,
      haveSpotify: '',
      askForEmail: false,
      capitalized: false,
      defaultImage: '/static/img/img-placeholder.jpg',
      spotifyArtists: [],
      emojisRegex: new RegExp('[\\p{Emoji}]', 'gu'),
      invalidTitle: false,
      locationSettings: {},
      saving: false,
      lang: '',
      yesSoundCloud: false,
      changes: defaultDiacriticsRemovalMap,
      genres: _.map(genres, (genre, key) => { return key }),
      countries: _.map(countries, (country) => { return { text: country.name, id: country.name } }),
      prevName: '',
      prevLastName: '',
      artist: {
        _id: '',
        spotify_id: '',
        name: '',
        main_genre: '',
        cover_image: '',
        legal_name: '',
        legal_last_name: '',
        legal_country: 'United States',
        bio: '',
        website: '',
        facebook: '',
        instagram: '',
        twitter: '',
        payment_method: ''
      },
      myCroppa: null,
      selectedImage: '',
      soundCloudURL: '',
      soundCloudGenericURL: '',
      publishedDistros: 0,
      hasSoundcloudWhitelist: false,
      user: {},
      showSocialNetworkWarning: false,
      spotifyProfile: null,
      loadingSpotifyArtists: false,
      allArtist: [],
      spotifyPrev: null,
      spotifyNext: null,
      moment: moment,
      activeService: {
        _id: '',
        total: 0,
        payment_method: '',
        service_type: {},
        paidAt: ''
      },
      showManualSpotifyId: false,
      manualSpotifyId: '',
      manualSpotifyIdError: '',
      manualSpotifyIdSuccess: '',
      currentArtist: {
        text: '',
        cover_image_small: ''
      }
    }
  },
  computed: {
    hasFile: function () {
      return this.myCroppa && this.myCroppa.getChosenFile && this.myCroppa.getChosenFile()
    }
  },
  methods: {
    validateLegalName: function () {
      if (!this.artist.legal_name && !this.artist.legal_last_name) {
        return
      }

      if (this.prevName === this.artist.legal_name && this.prevLastName === this.artist.legal_last_name) {
        return
      }

      this.prevName = this.artist.legal_name
      this.prevLastName = this.artist.legal_last_name

      this.invalidNameReason = ''

      User.validateLegalName(this.artist.name, this.artist.legal_name, this.artist.legal_last_name).then(response => {
        if (!response.data.valid && response.data.reason) {
          this.invalidNameReason = response.data.reason

          window.$('html, body').animate({
            scrollTop: window.$(this.$refs.legalNameForm).offset().top
          }, 500)
        }
      }).catch((err) => {
        console.log('Error when trying to request name validation', err)
      })
    },
    removeSpotifyProfile: function () {
      if (!this.spotifyProfile.id) {
        this.alreadyHaveSpotify = false
      }
      this.spotifyProfile = null
      this.searchSpotifyArtist()
    },
    selectSpotifyArtist: function (artist) {
      if (this.artist.name !== artist.name) {
        window.swal({
          title: this.$t('match_artist_name_spotify'),
          icon: 'info',
          closeOnEsc: false,
          closeOnClickOutside: false,
          buttons: {
            cancel: {
              text: this.$t('cancel'),
              visible: true,
              className: 'btn btn-default'
            },
            confirm: {
              text: this.$t('confirm'),
              className: 'btn btn-success'
            }
          }
        }).then(result => {
          if (result) {
            this.artist.name = artist.name
            this.spotifyProfile = artist
          }
          window.$(this.$refs.spotifyModal).modal('hide')
        })
      } else {
        this.spotifyProfile = artist
        window.$(this.$refs.spotifyModal).modal('hide')
      }
    },
    createSpotifyProfile: function () {
      this.currentArtist = {
        text: this.artist.name,
        cover_image_small: this.artist.cover_image_small || ''
      }
      this.spotifyProfile = {
        id: '',
        uri: '',
        name: this.currentArtist.text,
        new: true,
        images: [],
        cover_image_small: ''
      }
      window.$(this.$refs.spotifyModal).modal('hide')
    },
    validateName: function () {
      this.artist.name = [...this.artist.name]
        .filter(char => {
          // Allow numbers and other valid characters
          const isDigit = /\d/.test(char) // Matches 0-9
          const isEmoji = this.emojisRegex.test(char) // Matches emojis
          return isDigit || !isEmoji // Allow digits or non-emoji characters
        })
        .join('') // Rebuild the filtered string
    },
    showTitleInstructions: function () {
      window.$(this.$refs.tittleValidationModal).modal('show')
    },
    replaceImage: function () {
      // Remove Image
      Upload.removeImage(this.artist.cover_image.split('/').pop(), 'artist-images').then(response => {
        this.artist.cover_image = ''
        this.artist.cover_image_small = ''

        if (this.artist._id) {
          this.saveArtist({ skipRedirect: true })
        }
      })
    },
    zoomIn: function () {
      this.myCroppa.zoomIn()
    },
    zoomOut: function () {
      this.myCroppa.zoomOut()
    },
    uploadImage: function (_callback) {
      this.myCroppa.generateBlob(
        blob => {
          Upload.uploadImage(blob, 'artist-images').then(response => {
            this.artist.cover_image = response.data.full
            this.artist.cover_image_small = response.data.small

            if (_callback) {
              _callback()
            }
          })
        },
        'image/jpeg',
        0.8
      ) // 80% compressed jpeg file
    },
    saveArtist: function (params) {
      params = params || { skipRedirect: false }

      let message = this.$t('artist_created')

      if (this.artist.name.match(/Records|Recs/gi)) {
        this.saving = false
        return this.$notify({ message: `(Records, Recs) ${this.$t('invalid_words')}` }, 'warning', 'fa-exclamation')
      }

      if (this.artist._id) {
        message = this.$t('artist_updated')
      } else {
        window.ga && window.ga('send', 'pageview', '/artist-created')
      }

      if (this.askForEmail && this.user.email) {
        User.update({ email: this.user.email }).then(() => {}).catch(() => {})
      }

      if (!this.user.last_name) {
        User.update({ name: this.artist.legal_name, last_name: this.artist.legal_last_name }).then(() => {}).catch(() => {})
      }

      Artists.save(this.artist).then(async response => {
        this.saving = false
        this.$notify({ message }, 'success', 'fa fa-check')

        if (!this.artist._id) {
          window.ga && window.ga('send', {
            hitType: 'event',
            eventCategory: 'Artist',
            eventAction: 'Created',
            eventLabel: 'Artist Created'
          })
        }

        this.$eventBus.$emit('updateArtists')

        if (!params.skipRedirect) {
          let artists = null

          try {
            artists = await Artists.getAll()
          } catch (error) {}

          if (artists && artists.data.length >= 1) {
            try { // mark tutorial for firstSteps
              User.saveFirstSteps().then(response => {})
            } catch (error) {}
          }

          // First artist? Mark registration as complete
          if (artists && artists.data.length === 1) {
            window.fbq && window.fbq('track', 'CompleteRegistration', { value: 0.1, currency: 'USD', content_name: 'Signup', status: 'complete' })
            window.gtag && window.gtag('event', 'conversion', {'send_to': 'AW-323371496/HLCyCPCehPECEOiDmZoB'})
            window.smartlook && window.smartlook('track', 'First Artist Created')
            window.twttr && window.twttr.conversion.trackPid('o2s47', { tw_sale_amount: 0, tw_order_quantity: 0 })

            window.gtag && window.gtag('event', 'page_view', {
              page_title: document.title,
              page_location: 'https://indiefy.net/account-created',
              page_path: '/account-created',
              send_to: 'UA-80876238-1'
            })

            window.gtag && window.gtag('event', 'page_view', {
              page_title: document.title,
              page_location: 'https://indiefy.net/account-created',
              page_path: '/account-created',
              send_to: 'AW-877256789'
            })

            let urlToGo = ''
            if (!this.allArtist.length && !this.locationSettings.hide_basic) {
              urlToGo = '/dashboard'
            } else {
              if (!this.user.subscription && this.locationSettings.hide_basic) {
                urlToGo = '/dashboard'
              } else {
                urlToGo = '/new-distribution'
              }
            }

            setTimeout(() => {
              this.$router.push(urlToGo)
            }, 500)
          } else {
            this.$router.push('/artists')
          }
        }
      }).catch(err => {
        this.saving = false
        let error = err.response.data.name || ''

        switch (error) {
          case 'already_exists':
            this.$notify({ title: 'Oops', message: this.$t('artist_name_exists') }, 'danger', 'fa-exclamation')
            break
          case 'proweekend_limit':
            this.$notify({ title: 'ProWeekend', message: this.$t('proweekend_limit') }, 'danger', 'fa-exclamation')
            break
          case 'resolve_application_first':
            this.$notify({ title: 'Oops', message: this.$t('resolve_application_first') }, 'danger', 'fa-exclamation')
            break
          case 'invalid_legal_name_or_legal_last_name':
            this.$notify({ message: this.$t('invalid_legal_name_or_legal_last_name') }, 'danger', 'fa-exclamation')
            break
          case 'legal_name_required':
            this.$notify({ message: this.$t('legal_name_required') }, 'danger', 'fa-exclamation')
            break
          case 'legal_last_name_required':
            this.$notify({ message: this.$t('legal_last_name_required') }, 'danger', 'fa-exclamation')
            break
        }
      })
    },
    removeDiacritics: function (str) {
      _.map(this.changes, (item) => {
        str = str.replace(item.letters, item.base)
      })
      return str.normalize('NFD').replace(/[^a-zA-Z0-9]/g, '').toLowerCase()
    },
    submitArtist: function () {
      if (this.saving) {
        return
      }

      if (!this.artist.name) {
        return this.$notify({ message: this.$t('name_required') }, 'warning', 'fa-exclamation')
      }

      if (!this.artist.legal_name) {
        return this.$notify({ message: this.$t('legal_name_required') }, 'warning', 'fa-exclamation')
      }

      if (this.artist.legal_name.length < 2) {
        return this.$notify({ message: this.$t('legal_name_required_two_characters') }, 'warning', 'fa-exclamation')
      }

      if (!this.artist.legal_last_name) {
        return this.$notify({ message: this.$t('legal_last_name_required') }, 'warning', 'fa-exclamation')
      }

      if (this.artist.legal_last_name.length < 2) {
        return this.$notify({ message: this.$t('legal_last_name_required_two_characters') }, 'warning', 'fa-exclamation')
      }

      Artists.checkArtistNameSpotifyWatchlist(this.removeDiacritics(this.artist.name)).then(response => {
        if (response.data.length) {
          return this.$notify({ message: this.$t('invalid_artist_name') }, 'warning', 'fa-exclamation')
        } else {
          if (!this.artist.main_genre) {
            return this.$notify({ message: this.$t('main_genre_required') }, 'warning', 'fa-exclamation')
          }

          if (!this.artist.legal_country) {
            return this.$notify({ message: this.$t('country_required') }, 'warning', 'fa-exclamation')
          }

          this.validateSocialNetworks()

          if (this.showSocialNetworkWarning) {
            return this.$notify({ message: this.$t('one_social_required') }, 'warning', 'fa-exclamation')
          }

          this.saving = true

          this.artist.spotify_id = ''
          new Promise(resolve => {
            if (this.spotifyProfile && !this.spotifyProfile.new) {
              Artists.getSpotifyArtistIndiefy(this.spotifyProfile.uri.replace('spotify:artist:', '')).then(response => {
                if (!response.data.duplicated) {
                  if (this.spotifyProfile.uri) {
                    this.artist.spotify_id = this.spotifyProfile.uri
                  } else {
                    this.artist.create_spotify_profile = 1
                  }
                  resolve()
                } else {
                  this.saving = false
                  var html = document.createElement('div')
                  html.setAttribute('style', 'padding:0 40px')
                  html.innerHTML = '<br/>' + this.$t('duplicate_spotify_description') + '<br/><br/><br/>'
                  window.swal({
                    title: this.$t('attention'),
                    content: html,
                    closeOnEsc: false,
                    closeOnClickOutside: false,
                    buttons: {
                      confirm: {
                        text: this.$t('i_understand'),
                        className: 'btn btn-primary'
                      }
                    }
                  })
                }
              })
            } else {
              resolve()
            }
          }).then(() => {
            if (this.hasFile) {
              this.uploadImage(() => {
                this.saveArtist()
              })
            } else {
              this.saveArtist()
            }
          })
        }
      })
    },
    openWhitelistModal: function () {
      window.$(this.$refs.requestWhitelistModal).modal('show')
    },
    sendRequestSoundCloudWhitelist: function () {
      if (!this.artist || !this.artist._id) {
        return this.$notify({ message: this.$t('artist_required') }, 'warning', 'fa-exclamation')
      }

      let data = {
        artist: this.artist,
        soundcloud_url: this.soundCloudURL.trim(),
        soundcloud_generic_url: this.soundCloudGenericURL.trim()
      }

      Artists.sendRequestSoundcloudWhitelist(data).then(response => {
        this.hasSoundcloudWhitelist = true

        window.swal({
          title: this.$t('success'),
          text: this.$t('request_whitelist_success'),
          className: 'icon-modal',
          icon: 'success',
          buttons: {
            confirm: {
              text: this.$t('understood'),
              className: 'btn btn-success'
            }
          }
        })
      })
    },
    getArtistReleases: function () {
      Distributions.getAll({artist: this.artist._id}).then(response => {
        this.distributions = response.data
        this.publishedDistros = _.filter(
          this.distributions,
          item => item.status === 3
        ).length
      })
    },
    validateSocialNetworks: function () {
      this.socialNetworks = []

      if (this.artist.instagram) {
        this.socialNetworks.push(this.artist.instagram)
      }

      if (this.artist.twitter) {
        this.socialNetworks.push(this.artist.twitter)
      }

      if (this.artist.facebook) {
        this.socialNetworks.push(this.artist.facebook)
      }

      if (this.artist.spotify) {
        this.socialNetworks.push(this.artist.spotify)
      }

      if (this.spotifyProfile && (this.spotifyProfile.uri || this.spotifyProfile.new)) {
        this.socialNetworks.push(this.spotifyProfile.uri || this.spotifyProfile.new)
      }

      if (!this.socialNetworks.length) {
        this.showSocialNetworkWarning = true
      } else {
        this.showSocialNetworkWarning = false
      }
    },
    searchSpotifyArtist: function (urlSearch = false) {
      this.spotifyArtists = []
      this.spotifyPrev = null
      this.spotifyNext = null
      this.loadingSpotifyArtists = true

      Artists.checkArtistName(this.artist.name, urlSearch).then(response => {
        if (response.data.results.length) {
          response.data.results.sort(function (a, b) {
            if (a.followers.total > b.followers.total) { return -1 }
            if (a.followers.total < b.followers.total) { return 1 }
            return 0
          })
          this.spotifyPrev = response.data.previous
          this.spotifyNext = response.data.next
          this.spotifyArtists = response.data.results
        }

        this.loadingSpotifyArtists = false
      }).catch(e => {
        this.loadingSpotifyArtists = false
      })

      window.$(this.$refs.spotifyModal).modal('show')
    },
    verification_modal: function () {
      let html = document.createElement('div')
      html.innerHTML =
        '<div class="pr-4 pl-4 text-center">' +
          '<b>' + this.$t('attention') + ':</b>  ' +
          this.$t('create_artist_verif') + '<br><br><br>' +
          '<div class="custom-control custom-checkbox">' +
            '<input type="checkbox" class="custom-control-input" id="i_understand" />' +
            '<label class="custom-control-label label-break-spaces" for="i_understand">' +
              this.$t('i_understand') +
            '</label>' +
          '</div>' +
        '</div>'
      window.swal({
        title: this.$t('verified_account'),
        content: html,
        closeOnClickOutside: false,
        closeOnConfirm: true,
        buttons: {
          confirm: {
            text: this.$t('create_artist'),
            className: 'btn btn-primary'
          }
        }
      }).then(confirm => {
        if (confirm) {
          if (!document.querySelector('#i_understand').checked) {
            setTimeout(() => {
              this.verification_modal()
            }, 100)
          }
        }
      })
    },
    disabledClass: function (socialNetwork) {
      let disabledVal = false
      if (this.artist.social_networks_status && this.artist.social_networks_status[socialNetwork]) {
        disabledVal = !!(this.artist.social_networks_status[socialNetwork].status === 1)
      }
      return disabledVal
    },
    deleteService: function (id) {
      this.saving = true
      this.activeService = {
        _id: '',
        total: 0,
        payment_method: '',
        service_type: {},
        paidAt: ''
      }
      setTimeout(() => {
        this.$notify({ message: 'You have to select a service to continue' }, 'warning', 'fa-exclamation')
        this.$router.push('/artists')
      }, 200)
    },
    validateSpecialChar: function (e) {
      let char = String.fromCharCode(e.keyCode)
      let exp1 = /[!"/=#%¡¿*+;&:_°´¨~`¬⊂･ω)(?^${}|[\]\\]/g
      let exp2 = /^([^0-9]*)$/

      if (!exp1.test(char) && exp2.test(char) && char !== '-') return true
      else e.preventDefault()
    },
    letterNumbersValidation (e) {
      if (!e.key.match(/^[a-zA-ZÀ-ÿ '-]+$/)) {
        e.preventDefault()
      }
    },
    handleInput: function (fromSourceComponent) {
      // This regex now handles both the detection of emojis and the detection of unwanted symbols like arrows, punctuation, and pictographs. It supports inputs in all languages. Suggestiong provided by IA
      const emojiRegex = new RegExp('[\\p{Emoji}\\p{Sc}\\p{Sm}\\p{Sk}\\p{So}\\p{P}\\u2190-\\u21FF\\u2700-\\u27BF\\u207D\\u207E\\u208D\\u208E]', 'gu')
      this.artist[fromSourceComponent] = this.artist[fromSourceComponent].replace(emojiRegex, '')
    },
    cancelManualSpotifyId () {
      this.showManualSpotifyId = false
      this.manualSpotifyId = ''
      this.manualSpotifyIdError = ''
      this.manualSpotifyIdSuccess = ''
    },
    async submitManualSpotifyId () {
      let id = this.manualSpotifyId.trim()
      let artistId = null

      // Check for Spotify URI
      let uriMatch = id.match(/^spotify:artist:([a-zA-Z0-9]{22})$/)
      if (uriMatch) {
        artistId = uriMatch[1]
      }

      // Check for Spotify URL
      let urlMatch = id.match(/^https?:\/\/open\.spotify\.com\/artist\/([a-zA-Z0-9]{22})(\?.*)?$/)
      if (urlMatch) {
        artistId = urlMatch[1]
      }

      // Check for plain ID (must be exactly 22 alphanumeric chars, nothing else)
      let idMatch = id.match(/^[a-zA-Z0-9]{22}$/)
      if (idMatch) {
        artistId = id
      }

      if (!artistId) {
        this.manualSpotifyIdError = 'invalid_spotify_artist_id'
        this.manualSpotifyIdSuccess = ''
        return
      }

      // Check if the Spotify ID is already used
      try {
        const response = await Artists.getSpotifyArtistIndiefy(artistId)
        if (response.data.duplicated) {
          this.manualSpotifyIdError = 'spotify_artist_duplicated'
          this.manualSpotifyIdSuccess = ''
          return
        }
      } catch (e) {
        this.manualSpotifyIdError = 'error_checking_spotify_id'
        this.manualSpotifyIdSuccess = ''
        return
      }

      this.artist.spotify_id = 'spotify:artist:' + artistId
      this.spotifyProfile = {
        id: artistId,
        uri: 'spotify:artist:' + artistId,
        name: '',
        new: false,
        images: [],
        cover_image_small: ''
      }
      this.manualSpotifyIdError = ''
      this.manualSpotifyIdSuccess = 'spotify_artist_saved'
      setTimeout(() => {
        this.cancelManualSpotifyId()
        window.$(this.$refs.spotifyModal).modal('hide')
      }, 1200)
    }
  },
  created: function () {
    this.user = this.$user
    this.lang = this.$i18n.locale

    if (!this.user.email) {
      this.askForEmail = true
    }

    if (this.user.freeze) {
      this.$notify({ message: this.$t('freeze_user_message') }, 'warning', 'fa-exclamation')
      return this.$router.push('/artists')
    }

    Artists.getAll().then(response => {
      this.allArtist = response.data

      Public.getLocationSettings().then(responseSettings => {
        this.locationSettings = responseSettings.data

        if ((this.allArtist.length >= 1 && (!this.user.subscription || this.user.subscription.plan_name === 'indiefy_lite'))) {
          let reason = 'basic_artist_limit'

          if (this.locationSettings.hide_basic) {
            reason = 'artist_limit_location'
          }

          setTimeout(() => {
            if (this.allArtist.length && this.allArtist[0].key !== this.$route.params.id) {
              this.$router.push('/upgrade?from=' + reason)
            }
          }, 10)
        }
      })

      this.loading = false
    })

    if (this.$route.params.id) {
      Artists.get(this.$route.params.id).then(response => {
        this.artist = response.data

        this.prevName = response.data.legal_name
        this.prevLastName = response.data.legal_last_name

        let payoutMethods = {}
        _.each(_.clone(countries), elem => {
          if (this.user.active_country === elem.code) {
            payoutMethods = elem.payout_methods
          }
        })
        if (payoutMethods) {
          if (_.contains(payoutMethods, 'stripe')) {
            this.artist.payment_method = 'stripe'
          } else if (_.contains(payoutMethods, 'wise')) {
            this.artist.payment_method = 'wise'
          } else {
            this.artist.payment_method = ''
          }
        } else {
          this.artist.payment_method = ''
        }

        this.validateSocialNetworks()
        this.getArtistReleases()

        Artists.getRequestSoundcloudWhitelist(this.artist._id).then(response => {
          if (response.data) {
            this.hasSoundcloudWhitelist = true
          }
        })
        this.spotifyProfile = null
        this.alreadyHaveSpotify = false

        if (this.artist.spotify_id) {
          let spotifyId = this.artist.spotify_id.replace('spotify:artist:', '')
          Artists.getSpotifyArtist(spotifyId).then(response => {
            this.spotifyProfile = response.data
            this.alreadyHaveSpotify = true
          })
        }

        // get service if have
        ServicesOnDemand.getServiceByArtist(this.artist._id).then(response => {
          this.activeService = response.data || {}
        })
        this.$forceUpdate()
      }, () => {
        if (!this.$user.subscription) {
          this.$notify({ message: this.$t('artist_limit_reached') }, 'warning', 'fa-exclamation')
          setTimeout(() => {
            this.$router.push('/artists')
          }, 1000)
        }
      })
    } else {
      if (this.user.country) {
        let country = _.find(countries, country => country.code.toLowerCase() === this.user.country.toLowerCase())

        if (country) {
          this.artist.legal_country = country.name
        }
      }

      if (this.user.name) {
        this.artist.legal_name = this.user.name
      }

      if (this.user.last_name) {
        this.artist.legal_last_name = this.user.last_name
      }

      this.prevName = this.artist.legal_name
      this.prevLastName = this.artist.legal_last_name
    }

    window.smartlook && window.smartlook('record', { forms: true, emails: true })
  },
  components: {
    Select2
  },
  watch: {
    'artist.instagram': function (currentValue, oldValue) {
      this.validateSocialNetworks()
    },
    'artist.twitter': function (currentValue, oldValue) {
      this.validateSocialNetworks()
    },
    'artist.facebook': function (currentValue, oldValue) {
      this.validateSocialNetworks()
    }
  },
  mounted: function () {
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/sass/atlantis/_variables.scss';

#artist-image {
  width: 200px;
  height: 200px;
  border-radius: 3px;
}

.soundcloud-container {
  width: 85px;
  img {
    width: 50px
  }
}

.mb-custom{
  margin-bottom: 35px;
}
.profile-selector {
  border: dashed 2px #a5a5a5;
  cursor: pointer;
  color: #444;
  transition: all ease 0.3s;
  animation-duration: 0.8s;
  &:hover {
    color: #7d7d7d  !important;
    border-color: #e6e5e5 !important;
  }
}

.logo-paypal {
  max-width: 80px;
}

.logo-stripe {
  max-width: 85px;
}

.text-underline {
  text-decoration: underline;
}

.custom-radio .custom-control-input:checked~.custom-control-label::before {
    background-color: $primary-color;
}

.spotify-paginator {
  .paginator {
    width: 49%;
    display: inline-block;
    &.previous {
      text-align: left;
      .btn {
        color: #5714ff !important;
      }
    }
    &.next {
      text-align: right;
      .btn {
        color: #5714ff !important;
      }
    }
  }
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 650px;
  }
  .modal-swal .modal-body {
    padding: 0 70px;
    width: 100%;
  }
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/ArtistForm.vue